import { Heart, Globe, Star, Users } from "lucide-react";

const objectives = [
  {
    icon: Heart,
    title: "Fierté & Identité",
    description: "Chaque adhésif porte en lui l'âme de la Tunisie. Nous créons des pièces qui célèbrent nos racines avec élégance.",
    accent: "from-[hsl(var(--terracotta))] to-[hsl(var(--terracotta-glow))]",
  },
  {
    icon: Globe,
    title: "Pont entre deux terres",
    description: "Nés en Tunisie, épanouis au Canada 🍁. Nos créations unissent ces deux mondes qui nous ont façonnés.",
    accent: "from-[hsl(var(--mediterranean))] to-[hsl(var(--mediterranean-light))]",
  },
  {
    icon: Star,
    title: "Excellence artisanale",
    description: "Du design 3D premium, pensé avec soin et fabriqué avec passion pour durer et impressionner.",
    accent: "from-[hsl(var(--gold))] to-[hsl(var(--gold-light))]",
  },
  {
    icon: Users,
    title: "Solidarité & Générosité",
    description: "Une partie de chaque vente soutient les familles tunisiennes dans le besoin. Acheter, c'est aussi donner.",
    accent: "from-[hsl(var(--accent))] to-[hsl(var(--olive))]",
  },
];

export const MissionSection = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Rich background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-[hsl(var(--cream))] to-background" />
      
      {/* Radial glows */}
      <div className="absolute top-10 left-1/4 w-[500px] h-[500px] rounded-full bg-[hsl(var(--terracotta)/0.06)] blur-[120px] pointer-events-none" />
      <div className="absolute bottom-10 right-1/4 w-[400px] h-[400px] rounded-full bg-[hsl(var(--gold)/0.08)] blur-[100px] pointer-events-none" />

      {/* Zellige pattern */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.03] pointer-events-none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="zellige-mission" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
            <path d="M30 0L60 30L30 60L0 30Z" fill="none" stroke="currentColor" strokeWidth="0.5" />
            <circle cx="30" cy="30" r="4" fill="none" stroke="currentColor" strokeWidth="0.3" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#zellige-mission)" />
      </svg>

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span
            className="inline-block text-sm font-body font-semibold tracking-[0.2em] uppercase mb-4 bg-clip-text text-transparent"
            style={{ backgroundImage: "linear-gradient(135deg, hsl(18 78% 50%), hsl(42 72% 55%))" }}
          >
            Notre Mission
          </span>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-foreground mb-5">
            Plus qu'un adhésif, une cause noble 🤲
          </h2>
          <p className="text-muted-foreground font-body max-w-2xl mx-auto text-lg leading-relaxed">
            EL FAZA est né d'un rêve simple : porter la fierté tunisienne partout dans le monde, 
            tout en redonnant à ceux qui en ont besoin.
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {objectives.map((obj, i) => (
            <div
              key={obj.title}
              className="group relative rounded-2xl bg-card/80 backdrop-blur-sm border border-border hover:border-primary/20 transition-all duration-500 hover:shadow-[var(--shadow-warm)] overflow-hidden"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              {/* Top accent line */}
              <div className={`h-1 bg-gradient-to-r ${obj.accent}`} />
              
              <div className="p-7">
                <div className="flex items-start gap-4">
                  <div className={`flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br ${obj.accent} flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <obj.icon className="w-5 h-5 text-white" />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-display font-bold text-foreground text-lg mb-1.5">
                      {obj.title}
                    </h3>
                    <p className="font-body text-muted-foreground text-sm leading-relaxed">
                      {obj.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom decorative dots */}
        <div className="flex justify-center gap-2 mt-12">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="w-2 h-2 rounded-full"
              style={{
                background: i === 2
                  ? "hsl(42 72% 55%)"
                  : "hsl(18 78% 50%)",
                opacity: 0.3,
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
